<template>
  <div id="wrapper" class="d-flex flex-column">
    <header class="header-global">
      <app-header></app-header>
    </header>

    <main class="flex-fill position-relative">
      <!-- ADD THIS -->
      <survey-banner></survey-banner>

      <nuxt />
    </main>

    <footer>
      <app-footer></app-footer>
    </footer>
  </div>
</template>

<script>
import AppHeader from '~/components/AppHeader'
import AppFooter from '~/components/AppFooter'
import SurveyBanner from '~/components/SurveyBanner.vue'

export default {
  components: {
    AppHeader,
    SurveyBanner,
    AppFooter
  }
}
</script>

<style>
body, #wrapper {
  min-height: 100vh;
}
</style>
